import './WdpTable.scss'
import { useState, useEffect, useCallback, useRef } from "react";
import { GoabTable, GoabTableSortHeader } from "@abgov/react-components"
import { GoabTableSortDirection } from '@abgov/ui-components-common';
//import { wdpUtil } from '../../common/utils/util';
interface colHeader {
  text: string;
  name: string
  ref: React.MutableRefObject<HTMLTableHeaderCellElement | null>,
  direction: GoabTableSortDirection,
}

const createHeaders = (headers: any[]) => {

  if (headers === undefined || headers.length === 0) {
    return null;
  }
  return headers.map((item: any): colHeader => ({
    text: item.text,
    name: item.name,
    ref: useRef<HTMLTableHeaderCellElement | null>(null),
    direction: item.sortDir ?? 'none',//((item === 'Username ( email )') ? 'none' : 'none'),
  }));
}

export const WdpTable = (props: any) => {

  // state for table resize functionality
  const [tableHeight, setTableHeight] = useState<string | number>('auto');
  const [activeIndex, setActiveIndex] = useState(null);
  const [tableElement, setTableElement] = useState<HTMLTableElement>();
  // init table header
  const columns = createHeaders(props.tableHeaders);
  const tableWrap = useRef<HTMLDivElement | null>(null);

  // mouseMove
  const mouseMove = useCallback((e: MouseEvent) => {
    e.stopPropagation();
    if (tableWrap.current != null && columns && columns?.length !== 0) {
      const gridColumns = columns.map((col, i) => {
        if (i === activeIndex) {
          // Calculate the column width
          // let x = e.pageX;
          let width = 0;
          if (col.ref.current) {
            const rc = col.ref.current.getBoundingClientRect();
            let delta = e.clientX - rc.right;
            width = col.ref.current.offsetWidth + delta;
          }
          if (width >= 120) {
            return `${width}px `;
          }
        }
        // Otherwise return the previous width (no changes)
        return `${col.ref.current ? col.ref.current.offsetWidth : 0}px `;
      });

      // Assign the px values to the table
      if (tableElement != null) {
        tableElement.style.gridTemplateColumns = `${gridColumns.join(' ')}`;
      }
    }

  }, [activeIndex, columns, tableElement]);

  const removeListeners = useCallback(() => {
    tableElement?.removeEventListener('mousemove', mouseMove);
    tableElement?.removeEventListener('mouseup', removeListeners);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mouseMove]);

  /*********************************************************************************
   *  mouse Down event
   * @param index 
   ********************************************************************************/
  const mouseDown = (index: any) => {
    setActiveIndex(index);
    

    // samer this is temp 
    /*if (tableWrap.current != null) {
      if (tableElement != null) {
        setTableHeight(tableElement.offsetHeight);
      }
    }*/
  }
  /*******************************************************************************
   * mouseup event
  ********************************************************************************/
  const mouseUp = useCallback((e:MouseEvent) => {
    e.stopPropagation();
    setActiveIndex(null);
    removeListeners();
  }, [setActiveIndex, removeListeners]);

  /*******************************************************************************
   * calc and set table hight after this comp got mounted 
  ********************************************************************************/
  useEffect(() => {
    // set divider height ..same a the table 
    if (activeIndex !== null) {
      tableElement?.addEventListener('mousemove', mouseMove);
      tableElement?.addEventListener('mouseup', mouseUp);
    }
    if (tableWrap.current != null) {
      if (tableElement != null) {
        setTableHeight(tableElement.offsetHeight);
        // console.log('TH:' + tableElement.offsetHeight);
      }
    }
    return () => {
      removeListeners();
    }
  }, [activeIndex, mouseMove, mouseUp, removeListeners, tableElement, setTableElement, columns]);

  /*******************************************************************************
   * calc and set table hight after this comp got mounted 
   * this is a JUST ONCE EFFECT
  ********************************************************************************/
  useEffect(() => {
    //  some styling overwrite
    if (tableWrap.current != null) {
      setTableElement(tableWrap.current.getElementsByTagName('table')[0]);
      if (tableElement != null && columns && columns.length !== 0) {
        setTableHeight(tableElement.offsetHeight);

        // reducne the TH height
        // const thead = tableElement.getElementsByTagName('thead')[0];
        // if(thead){
        //   const coll = thead.getElementsByTagName('goa-table-sort-header');
        //   for (let sheader of coll) {
        //     if (sheader != null) {
        //       let shadow = sheader?.shadowRoot;
        //       if (shadow?.children !== undefined) {
        //         const but = shadow.querySelector('button');
        //         if (but) {
        //           (but as HTMLElement).style.height = '30px';
        //           (but as HTMLElement).style.paddingTop = '6px';
        //           (but as HTMLElement).style.paddingBottom = '6px';
        //         }

        //       }
        //     }
        //   }
        // }

        // init table columns
        // Assign the px values to the table
        // const gridColumns = columns.map((col, _i) => 
        // {
        //   let wStr="200px ";
        //   if(!wdpUtil.isNullorUndefined(col.ref.current)){
        //     const w = col.ref.current?.offsetWidth;
        //     if(!wdpUtil.isNullorUndefined(w)){
        //       wStr=`${w}px `;
        //     }
        //   }
        //   return wStr;
        // });

        // tableElement.style.gridTemplateColumns = `${gridColumns.join(' ')}`;
      }
    }
    // 1 - make TD  padding same as TH (Goa) padding
    //tableElement?.classList.add("padding");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableElement]);
  /*******************************************************************************
   * 
   * @returns 
  ********************************************************************************/
  function populatetableHeader() {
    if (columns === null || columns === undefined || columns?.length === 0) {
      return;
    }
    return (
      <tr>
        {
          columns?.map((col: colHeader, i: number) => {
            return (
              <th ref={col.ref}  key={props.id+'-'+i+col.text}>
                {(props.resize === true) && <div
                  style={{ height: tableHeight }}
                  onMouseDown={() => { mouseDown(i) }}
                  className={`resize-handle ${activeIndex === i ? 'active' : 'idle'}`}
                ></div>
                }
                {col.name!==''? <GoabTableSortHeader key={props.id+'-'+i+col.text + '-sort'} name={col.name} direction={col.direction}><span><strong>{col.text}</strong></span></GoabTableSortHeader>:<div style={{paddingTop:"10px"}}><span><strong>{col.text}</strong></span></div>}
                
              </th>
            )
          }
          )
        }
      </tr>
    )
  }
  /*******************************************************************************
   * 
   * @returns 
   *******************************************************************************/
  function onSortEvent(param:any){
    if(props.sortDataFunc != null){
      props.sortDataFunc(props.id,param);
    }
  }
  return (
    <div key={props.id+'-table-wrap'}  id={props.id} className="table-wrapper" ref={tableWrap}>
      <GoabTable key={props.id+'-table'} onSort={  onSortEvent } width="100%" mb="xl">
        <thead key={props.id+'-thead'}>
          {
            populatetableHeader()
          }
        </thead>

        <tbody  key={props.id+'-tbody'}>
          {
            props.populatetableData()
          }
        </tbody>
      </GoabTable>
    </div>
  )
};
export default WdpTable;